<template>
  <div id="app" class="container">
	<img src="/img/header.svg" class="w-100" alt="Поиграй-ка">
    <div id="nav">
      <router-link to="/">Каталог</router-link> |
      <router-link to="/about">О каталоге</router-link>
    </div>
	<router-view></router-view>
	<img src="/img/footer.svg" class="w-100" alt="МКУ КИМЦ">
  </div>
</template>

<script>
export default {
 name: 'GamesLib',
 data () {
   return {}
 }
}
</script>

<style>
#app {
  font-family: Calibri, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background-color: #33cbcbff;
  background-image: url('/img/lines.svg');
  background-repeat: repeat;
  padding: 0;
  position: relative;
}

#app-logo {
	width: 30%;
	margin: 3rem;
}

#nav {
  position: absolute;
  top: 0;
  right: 1rem;
  padding: 1.4rem;
  font-size: 1rem;
  text-align: center;
  text-transform: uppercase;
}
@media (min-width: 992px) {
	#nav {
		font-size: 1.5rem;
		padding: 2.5rem;
	}
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
